import {
  Avatar,
  Box,
  Card,
  Container,
  Divider,
  Grid,
  Menu,
  MenuItem,
  Paper,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { s3baseUrl } from "src/config";
import { convertCurrencyToSign } from "src/utils/constant";

export default function InvoiceReview({
  inputs,
  paymentObject,
  taskCount,
  taskList,
}) {
  const [totalFinalTime, setTotalFinalTime] = useState("00:00");

  useEffect(() => {
    if (!Array.isArray(taskList)) return;
    let totalMin = 0;
  
    for (let i = 0; i < taskList.length; i++) {
      const time = taskList[i]?.time_track?.final_time;
      if (time && time.includes(":")) {
        const [hrsStr, minsStr] = time.split(":");
        const hrs = parseInt(hrsStr, 10) || 0;
        const mins = parseInt(minsStr, 10) || 0;
        totalMin += hrs * 60 + mins;
      }
    }
  
    const finalHrs = Math.floor(totalMin / 60);
    const finalMins = totalMin % 60;
  
    let formatted = "";
  
    if (finalHrs > 0) {
      formatted += `${finalHrs} hr${finalHrs > 1 ? "s" : ""}`;
      if (finalMins > 0) {
        formatted += ` ${finalMins} min${finalMins > 1 ? "s" : ""}`;
      }
    } else if (finalMins > 0) {
      formatted = `${finalMins} min${finalMins > 1 ? "s" : ""}`;
    } else {
      formatted = "0 min";
    }
  
    setTotalFinalTime(formatted);
  }, [taskList]);
  

  return (
    <Box sx={{ p: "0px 0px 40px 0px" }}>
      <Paper
        elevation={1}
        sx={{
          p: "0px 20px 24px",
          backgroundColor: "#fbfbfb",
          border: "2px Dashed #cbcbcb",
        }}
      >
        <Grid container spacing={2} mt={1}>
          <Grid
            item
            md={12}
            xs={12}
            display={"flex"}
            gap={"10px"}
            alignItems={"center"}
          >
            {inputs?.image && (
              <div className="d-flex justify-content-center">
                <img
                  src={
                    !inputs.image.startsWith("blob")
                      ? s3baseUrl + inputs.image
                      : inputs.image
                  }
                  height={"50px"}
                  width={"50px"}
                  style={{ objectFit: "contain" }}
                />
              </div>
            )}
            <Typography variant="h5" fontWeight="bold">
              INVOICE REVIEW
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Typography variant="h6" fontWeight={600} fontSize={"13px"}>
              Title
            </Typography>
            <Typography variant="subtitle">{inputs?.title}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Typography variant="h6" fontWeight={600} fontSize={"13px"}>
              Issue Date
            </Typography>
            <Typography variant="subtitle">
              {inputs?.invoice_issue_date}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Typography variant="h6" fontWeight={600} fontSize={"13px"}>
              Due Date
            </Typography>
            <Typography variant="subtitle">
              {inputs?.invoice_due_date}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Typography variant="h6" fontWeight={600} fontSize={"14px"}>
              Projects
            </Typography>
            <div>
              {inputs.projects.map((project, index) => (
                <Box key={project._id} display="flex" alignItems="center">
                  <Avatar
                    src={s3baseUrl + project.image}
                    alt={project.label}
                    sx={{ width: 20, height: 20, mr: 0.8 }}
                  />
                  <Typography variant="subtitle">
                    {project.label}
                    {index < inputs.projects.length - 1 && ","}
                  </Typography>
                </Box>
              ))}
            </div>
          </Grid>
     
          <>
            <Grid item md={12} xs={12}>
              <Divider
                textAlign="left"
                sx={{ width: "100%", borderColor: "black" }}
              >
                Client Detail
              </Divider>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <Typography variant="h6" fontWeight={600} fontSize={"13px"}>
                Bill To
              </Typography>
              <div className="d-flex align-items-center gap-2">
                <Avatar
                  src={s3baseUrl + inputs?.client?.image}
                  alt={inputs?.client?.first_name}
                  sx={{ width: 20, height: 20 }}
                />
                <Typography variant="subtitle">
                  {inputs?.client?.first_name + " " + inputs?.client?.last_name}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <Typography variant="h6" fontWeight={600} fontSize={"13px"}>
                Email
              </Typography>
              <Typography variant="subtitle">
                {inputs?.client?.email}
              </Typography>
            </Grid>
          </>
          {/* -------------------------------------- */}
          <Grid item md={12} xs={12}>
            <Divider
              textAlign="left"
              sx={{ width: "100%", borderColor: "black" }}
            >
              Description
            </Divider>
          </Grid>
          <Grid item xs={12}>
            {inputs.description && (
              <div style={{ wordBreak:"break-word" , fontSize:"13px"}}
                dangerouslySetInnerHTML={{
                  __html: inputs?.description,
                }}
              />
            )}
            {!inputs.description && (
              <div className="p-2" >
                <Typography fontSize={"13px"}>No Description Added</Typography>
              </div>
            )}
          </Grid>
          {/* -------------------------------------- */}
          <Grid item md={12} xs={12}>
            <Divider
              textAlign="left"
              sx={{ width: "100%", borderColor: "black" }}
            >
              Payment Detail
            </Divider>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid #919eab3d",
                borderRadius: 0.5,
                p: 2,
                backgroundColor: "#f9f9f9",
                // maxWidth: 500,
                // ml: "auto",
              }}
            >
              {/* Total Tasks & Time */}
              <Stack direction="row" justifyContent="space-between" mb={1}>
                <Typography fontSize={13} fontWeight={600}>
                Number of Billable Tasks
                </Typography>
                <Typography  fontSize={13}>{taskCount}</Typography>
              </Stack>
              <Divider sx={{ my: 1 , borderColor: 'grey.400' }} />
              <Stack direction="row" justifyContent="space-between" mb={1}>
                <Typography fontSize={13} fontWeight={600}>
                  Total Billable Time
                </Typography>
                <Typography  fontSize={13}>{totalFinalTime}</Typography>
              </Stack>
              <Divider sx={{ my: 1 , borderColor: 'grey.400' }} />
              <Stack direction="row" justifyContent="space-between" mb={1}>
                <Typography fontSize={13} fontWeight={600}>
                  Amount
                </Typography>
                <Typography  fontSize={13}>
                  {convertCurrencyToSign(paymentObject?.over_all_currency)}{" "}
                  {Number(inputs?.price_without_discount).toFixed(2)}
                </Typography>
              </Stack>
              <Divider sx={{ my: 1 , borderColor: 'grey.400' }} />
              <Stack direction="row" justifyContent="space-between" mb={1}>
                <Typography fontSize={13} fontWeight={600}>
                  Discount
                </Typography>
                <Typography  fontSize={13}>
                  - {convertCurrencyToSign(paymentObject?.over_all_currency)}{" "}
                  {Number(inputs?.discount).toFixed(2)}
                </Typography>
              </Stack>
              <Divider sx={{ my: 1 , borderColor: 'grey.400' }} />
              <Stack direction="row" justifyContent="space-between" mb={1}>
                <Typography fontSize={13} fontWeight={600}>
                  Tax ({Number(inputs?.tax)}%)
                </Typography>
                <Typography fontSize={13}>
                  {convertCurrencyToSign(paymentObject?.over_all_currency)}{" "}
                  {(
                    ((Number(inputs?.price_without_discount) -
                      Number(inputs?.discount)) *
                      Number(inputs?.tax)) /
                    100
                  ).toFixed(2)}
                </Typography>
              </Stack>

              <Divider sx={{ my: 1 , borderColor: 'grey.700' }} />

              {/* Subtotal */}
              <Stack direction="row" justifyContent="space-between">
                <Typography fontSize={14} fontWeight={700}>
                  Subtotal
                </Typography>
                <Typography fontWeight={700}>
                  {convertCurrencyToSign(paymentObject?.over_all_currency)}{" "}
                  {Number(inputs?.total).toFixed(2)}
                </Typography>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
